import React, { useEffect, useState, useCallback } from 'react'
import useTitle from "@/hooks/useTitle"
import EtTrinityGuidedServiceBarWelcome from '@/components/ai/EtTrinityGuidedServiceBarWelcome'
import EtTrinityWebLandingWelcomeVids from './powerup/EtTrinityWebLandingWelcomeVids'

const EtTrinityWebLandingWelcome = ({context, userId="", userOrgId="" }) => {
  
  // Author - Atul Pandey
  // First Created - 09 Mar 2025
  // Purpose - to act as the welcome page for Trinity Landing - Founder's message, new announcements
  // Updated - 09 Mar 2025 - added a playlist
  // Updated - 13 May 2025 - Refactored. Moved the original video playlist to EtTrinityWebLandingWelcomeVids
  // Updated - 13 May 2025 - Refactored. Added context prop and EtTrinityGuidedServiceBarWelcome
  // Updated - 13 May 2025 - Refactored for tab-based layout: Trinity (default) and Acclimatize (videos)
  // Updated - 15 May 2025 - Refactored. Removed the top tabs. 
  // Updated - 21 May 2025 - Refactored. Extracted token from context
  // Updated - 21 May 2025 - removed token prop and added email in context

  // 1a - Set Page Title
  useTitle('Trinity Powerup Home')

  // 1b - State to manage active tab
  const [activeTab, setActiveTab] = useState("trinity");

  return(
    <div className="w-full">
      <EtTrinityGuidedServiceBarWelcome context={context} userId={userId} userOrgId={userOrgId} />
      
      {/* Tab Menu */}
      {/* <div className="flex space-x-2 px-2 py-2 border-b border-gray-300">
        <button
          className={`px-4 py-2 rounded ${activeTab === 'trinity' ? 'bg-orange-600 text-white font-semibold' : 'bg-gray-100 text-gray-600'}`}
          onClick={() => setActiveTab('trinity')}
        >
          Trinity
        </button>
        <button
          className={`px-4 py-2 rounded ${activeTab === 'videos' ? 'bg-orange-600 text-white font-semibold' : 'bg-gray-100 text-gray-600'}`}
          onClick={() => setActiveTab('videos')}
        >
          Acclimatize
        </button>
      </div> */}

      {/* Tab Content */}
      {/* <div className="mt-2 overflow-y-auto">
        {activeTab === 'trinity' && (
          <div className="relative h-[75vh]">
            <EtTrinityGuidedServiceBarWelcome context={context} />
          </div>
        )}

        {activeTab === 'videos' && (
          <div className="h-[75vh]">
            <EtTrinityWebLandingWelcomeVids />
          </div>
        )}
      </div> */}
    </div>
  )

  
}

export default EtTrinityWebLandingWelcome